'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var TumblrIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<path d="M14.04 16.38c-0.7 0.33-1.33 0.57-1.9 0.7-0.57 0.13-1.18 0.2-1.84 0.2-0.75 0-1.41-0.1-1.98-0.29-0.57-0.19-1.06-0.46-1.47-0.82-0.41-0.35-0.69-0.73-0.84-1.13-0.16-0.4-0.24-0.98-0.24-1.73v-5.81h-1.81v-2.34c0.64-0.21 1.19-0.51 1.65-0.91 0.46-0.39 0.83-0.87 1.1-1.42 0.28-0.55 0.47-1.26 0.57-2.11h2.33v4.19h3.88v2.6h-3.88v4.25c0 0.96 0.05 1.58 0.15 1.85 0.1 0.27 0.29 0.49 0.56 0.65 0.36 0.22 0.78 0.33 1.24 0.33 0.83 0 1.65-0.27 2.47-0.82v2.61z"/>';
    case 'medium':
      return '<path d="M24.96 29.114c-1.242 0.592-2.368 1.010-3.374 1.248-1.008 0.237-2.099 0.358-3.269 0.358-1.33 0-2.504-0.171-3.528-0.51-1.021-0.341-1.891-0.826-2.614-1.451-0.722-0.632-1.222-1.299-1.501-2.008-0.28-0.709-0.419-1.736-0.419-3.082v-10.326h-3.214v-4.166c1.142-0.376 2.123-0.912 2.936-1.614 0.816-0.701 1.469-1.544 1.963-2.528 0.493-0.984 0.83-2.234 1.018-3.754h4.136v7.442h6.904v4.621h-6.904v7.55c0 1.706 0.090 2.802 0.27 3.288 0.176 0.483 0.509 0.87 0.994 1.16 0.646 0.39 1.381 0.586 2.21 0.586 1.474 0 2.938-0.485 4.394-1.453v4.64z"/>';
    case 'large':
      return '<path d="M37.44 43.67c-1.862 0.888-3.552 1.514-5.062 1.872-1.512 0.355-3.149 0.538-4.903 0.538-1.994 0-3.756-0.257-5.292-0.766-1.531-0.511-2.837-1.238-3.922-2.177-1.082-0.948-1.834-1.949-2.251-3.012-0.42-1.063-0.629-2.604-0.629-4.622v-15.49h-4.822v-6.25c1.714-0.564 3.185-1.368 4.404-2.422 1.224-1.051 2.203-2.316 2.945-3.792 0.739-1.476 1.246-3.35 1.526-5.63h6.204v11.162h10.356v6.931h-10.356v11.326c0 2.558 0.134 4.202 0.406 4.932 0.264 0.725 0.763 1.306 1.49 1.74 0.97 0.586 2.071 0.878 3.314 0.878 2.21 0 4.406-0.727 6.59-2.179v6.96z"/>';
    }
  }
});

module.exports = TumblrIcon;


/** WEBPACK FOOTER **
 ** ./atoms/icons/Tumblr.jsx
 **/